import Vue from 'vue'
import Router from 'vue-router'
import {Base64} from 'js-base64'

Vue.use(Router)

const router = new Router({
    routes: [
        {
            path: '/',
            name: 'index',
            component : resolve=>require(['../Home/index.vue'], resolve)
        },
        {
            path: '/price',
            name: 'Price',
            component : resolve=>require(['../Home/price.vue'], resolve)
        },
        {
            path: '/help',
            name: 'Help',
            component : resolve=>require(['../Home/help.vue'], resolve)
        },
        {
            path: '/about',
            name: 'About',
            component : resolve=>require(['../Home/about.vue'], resolve)
        },
        {
            path: '/admin',
            name: 'admin',
            redirect: 'AdminIndex',
            component: resolve => require(['../Admin/Layout.vue'], resolve),
            children: [
                {
                    path: 'index',
                    name: 'AdminIndex',
                    component: resolve => require(['../Admin/Common/index.vue'], resolve),
                    meta: {
                        requireAuth: true
                    },
                },
                {
                    path: 'admin/list',
                    name: 'AdminList',
                    component: resolve => require(['../Admin/User/lists.vue'], resolve),
                    meta: {
                        requireAuth: true
                    },
                },
                {
                    path: 'admin/edit',
                    name: 'AdminEdit',
                    component: resolve => require(['../Admin/User/edit.vue'], resolve),
                    meta: {
                        requireAuth: true
                    },
                },
                {
                    path: 'admin/acountlist',
                    name: 'AdminAcountList',
                    component: resolve => require(['../Admin/User/acountlist.vue'], resolve),
                    meta: {
                        requireAuth: true
                    },
                },
                {
                    path: 'Common/system',
                    name: 'System',
                    component: resolve => require(['../Admin/Common/system.vue'], resolve),
                    meta: {
                        requireAuth: true
                    },
                },
                {
                    path: 'Common/system_edit',
                    name: 'SystemEdit',
                    component: resolve => require(['../Admin/Common/system_edit.vue'], resolve),
                    meta: {
                        requireAuth: true
                    },
                },
                {
                    path: 'Order/lists',
                    name: 'OrderLists',
                    component: resolve => require(['../Admin/Order/lists.vue'], resolve),
                    meta: {
                        requireAuth: true
                    },
                },
                {
                    path: 'User/recharge',
                    name: 'Recharge',
                    component: resolve => require(['../Admin/User/recharge.vue'], resolve),
                    meta: {
                        requireAuth: true
                    },
                },
            ]
        },
        {
            path: '/merchant',
            name: 'merchant',
            redirect: 'pay',
            component: resolve => require(['../Merchant/Layout.vue'], resolve),
            children: [
                {
                    path: 'pay',
                    name: 'Pay',
                    component: resolve => require(['../Merchant/pay.vue'], resolve),
                    meta: {
                        requireMerchant: true
                    },
                },
                {
                    path: 'payinfo',
                    name: 'PayInfo',
                    component: resolve => require(['../Merchant/payinfo.vue'], resolve),
                    meta: {
                        requireMerchant: true
                    },
                },
                {
                    path: 'info',
                    name: 'Info',
                    component: resolve => require(['../Merchant/info.vue'], resolve),
                    meta: {
                        requireMerchant: true
                    },
                },
                {
                    path: 'order',
                    name: 'Order',
                    component: resolve => require(['../Merchant/order.vue'], resolve),
                    meta: {
                        requireMerchant: true
                    },
                },
                {
                    path: 'usercard',
                    name: 'UserCard',
                    component: resolve => require(['../Merchant/usercard.vue'], resolve),
                    meta: {
                        requireMerchant: true
                    },
                },
                {
                    path: '/merchant/acount',
                    name: 'MerchantAcount',
                    component: resolve => require(['../Merchant/acount.vue'], resolve)
                },
            ]
        },

        {
            path: '/login',
            name: 'Login',
            component: resolve => require(['../Admin/Login/login.vue'], resolve)
        },
        {
            path: '/merchant/login',
            name: 'MerchantLogin',
            component: resolve => require(['../Merchant/Login/login.vue'], resolve)
        },
        {
            path: '/merchant/register',
            name: 'MerchantRegister',
            component: resolve => require(['../Merchant/Login/register.vue'], resolve)
        },
        {
            path: '/merchant/forget',
            name: 'MerchantForget',
            component: resolve => require(['../Merchant/Login/forget.vue'], resolve)
        },
        {
            path: '/merchant/xieyi',
            name: 'MerchantXieyi',
            component: resolve => require(['../Merchant/Login/xieyi.vue'], resolve)
        },


    ]
})

router.beforeEach(function(to, from ,next){
    let token = localStorage.getItem('XX-Token');
    let exp_time = localStorage.getItem('exp_time')*1000;
    let end_time = new Date().getTime();
    // console.log(to.name);
    // console.log(token);
    // console.log(exp_time);
    // console.log(end_time);
    if (to.meta.requireAuth){
        if (!token || !exp_time || (end_time>exp_time)){
            next('/login');
        }
        else{
            next();
        }
    }
    if (to.meta.requireMerchant){
        if (!token || !exp_time || (end_time>exp_time)){
            next('/merchant/login');
        }
        else{
            next();
        }
    }
    next();
});

export default router



// WEBPACK FOOTER //
// ./src/router/index.js